import styles from './Contact.module.css';
import ContentBox from '../../components/ContentBox/ContentBox.jsx';

export default function Contact() {
    return (
        <main className={styles.contact}>
            <ContentBox 
                title="Kontakt"
                text={
                    <>
                        Skontaktuj się ze mną:<br/><br/>
                        <strong>Telefon:</strong> +48 503 466 099<br/>
                        <strong>Email:</strong> zaklinaczemowy@gmail.com<br/>
                        <strong>Adres:</strong>ul. Bobrowskiego 5/2, Kraków<br/><br/>
                        Zapraszam do umówienia wizyty telefonicznie lub mailowo.
                    </>
                }
                contentWidth="100%"
                leftSide={true}
            />

            <ContentBox 
                title="Godziny Pracy"
                text={
                    <>
                        Godziny pracy dostosowane do potrzeb i możliwości klientów.
                        Wizyty odbywają się po wcześniejszym umówieniu.
                    </>
                }
                contentWidth="100%"
                leftSide={true}
            />
        </main>
    );
}